module.exports = {
  key: '4784d051-dce8-4918-a0b1-9b429a23f8d6'
}



// WEBPACK FOOTER //
// ./src/config/cloudFunction.js